















import { computed, defineComponent } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
const name = 'ttam-label-optional';
export default defineComponent({
  name,
  props: {
    label: {
      type: String,
      default: '',
    },
    optionDesc: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    optionalClass: {
      type: String,
      default: '',
    },
    optionalVisible: {
      type: Boolean,
      default: true,
    },
    labelOptionKey: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const optionalDesc = computed(() => props.optionDesc || i18n.t('adgroup_optional'));
    const optionalLabelDesc = computed(() =>
      props.optionDesc ? ` (${props.optionDesc}) ` : i18n.t('common_optional'),
    );
    return {
      name,
      optionalDesc,
      optionalLabelDesc,
    };
  },
});
